import React, { useContext,  useState } from "react"
import PropTypes from "prop-types"
import * as Yup from 'yup';
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import { TextField,} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import { ModalContext } from "./Modal";
import paymentService from "../../services/payment.service";
import "../../styles/style.scss"
import { timeSessionDifference } from "../../constants/auth/timeSessionDifference";
import { tokenExpired } from "./ReferenceDetailScreen";
import { sesionExpired } from "../../constants/auth/sesionExpired";
import { useDispatch } from "react-redux";
export const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });


function ReferenceModal({dataPayment, updateReferenceTable}) {
        const dispatch = useDispatch()
        const validationSchema = Yup.object().shape({
        reference: Yup.string().matches(/^[a-zA-Z0-9-]*$/, 'Solo se permiten letras, números y guiones (sin espacios)')
        .max(20, 'Máximo 20 caracteres'),
        an8: Yup.string(),
        date: Yup.string(),
        paymentType: Yup.string()
        
        },[]);
        const [errorResposne, setErrorResponse] = useState(null)
        const [isLoading, setIsLoading] = useState(false)
        const sessionDifference = timeSessionDifference();
        const {
            register,
            handleSubmit,
            formState: { errors }
            } = useForm({
            resolver: yupResolver(validationSchema)
            });
        const {close} = useContext(ModalContext)
    if(errorResposne) return (<div className="container p-4">
        <p className="text-danger "> ERROR SOLICITAR DETALLE DE PAGO.</p>
    </div>)
        const handleUpdate=  (data) => {
            setIsLoading(true)
            try{
                const {reference} = data
                const dataToUpdate = {
                    ...dataPayment,
                reference: reference,
            }
                paymentService.updateReferenceService(dataPayment, reference).then((response) => {
                    if(!response.verifyData) {
                        updateReferenceTable(dataToUpdate)
                        close()
                         Swal.fire({
                                                icon: 'success',
                                                title:'Actualización exitosa',
                                                text: 'La referencia se actualizó correctamente',
                                                showConfirmButton: true,
                                                confirmButtonText: 'Aceptar'
                                                })
                                              
                    }
                    setIsLoading(false)
                }) .catch((error) => {
                        console.error(error)
                        if(sessionDifference > Number(tokenExpired)){
                        sesionExpired(dispatch, history)
                        }
                        setErrorResponse(true)
                        setIsLoading(false)
                    })
            }catch (error) {
                console.error(error)
                
                if(sessionDifference > Number(tokenExpired)){
                                  sesionExpired(dispatch, history);
                }
                setErrorResponse(true)
                setIsLoading(false)
            }
           
        }
    return (
        <div className="modal-content-custom d-flex justify-content-center ">
            <div className="row ">
                <div className="col-12">
                    <div className="d-flex align-items-center gap-1 mb-3">
                        <span className="fw-bold h4 mt-1 text-title">Actualizar Referencia</span>
                    </div>
                    
                    <form className="container p-2">
                        <div className="row">
                            <div className="form-group mb-4 col-12 col-md-6">
                                <TextField
                                    required
                                    id="an8"
                                    name="an8"
                                    size="small"
                                    label="Número de cliente"
                                    variant="outlined"
                                    disabled={true}
                                    value={dataPayment?.nuCustomer}
                                    {...register('an8')}
                                />
                            </div>
                            <div className="form-group mb-4 col-12 col-md-6">
                                <TextField
                                    required
                                    id="date"
                                    name="date"
                                    size="small"
                                    label="Fecha de pago"
                                    variant="outlined"
                                    {...register('date')}
                                    value={dataPayment?.billDate}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group mb-4 col-12 col-md-6">
                                <TextField
                                    required
                                    size="small"
                                    id="paymentType"
                                    name="paymentType"
                                    label="Monto"
                                    variant="outlined"
                                    {...register('paymentType')}
                                    value={dataPayment?.amount}
                                    disabled={true}
                                />
                            </div>
                            <div className="form-group mb-4 col-12 col-md-6">
                                <TextField
                                    required
                                    size="small"
                                    id="reference"
                                    name="reference"
                                    label="Referencia"
                                    variant="outlined"
                                    fullWidth
                                    {...register('reference')}
                                    error={!!errors.reference}
                                    helperText={errors.reference?.message}
                                />
                                </div>

                        </div>
                        <div className="form-group text-center text-md-end">
                            <button
                                type="submit"
                                onClick={handleSubmit(handleUpdate)}
                                className="btn custom-btn pt-2 pb-2"
                                aria-label="Submit Modal"
                            >
                                {isLoading ? <i className="fas fa-spinner fa-spin"></i> : "Actualizar"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    ) 
    
}
ReferenceModal.propTypes = {
    dataPayment: PropTypes.object,
    updateReferenceTable: PropTypes.func,
}
export default ReferenceModal
